<template>
  <div>
    <Header2 />
    <div class="financing-apply">
      <BreadcrumbGroup />
      <div class="financing-apply__progress-container">
        <FinancingProgress :setup="progressInfoSetup" />
      </div>
      <div class="financing-apply__form">
        <ContentComponent
          title="融资金额："
          mode="input"
          placeholder="请输入融资金额"
          :isRequire="true"
          unit=" 万元"
          :defaultValue="form.amount"
          v-model="form.amount"
        />
        <ContentComponent
          title="融资期限："
          mode="selector"
          :isRequire="true"
          placeholder="请选择融资期限"
          :selectOptions="applyDeadline"
          v-model="form.termRangeId"
        />
        <ContentComponent
          v-if="form.termRangeId === -1"
          title
          unit=" 个月"
          mode="input"
          placeholder="请输入融资期限"
          :defaultValue="form.timeLimit"
          v-model="form.timeLimit"
        />
        <ContentComponent
          title="融资类型："
          mode="selector"
          :isRequire="true"
          :selectOptions="financingCategory"
          v-model="form.financingCategory"
          placeholder="请选择融资类型"
          :disabled="userType === '个人'"
        />
        <ContentComponent
          title="资金用途："
          mode="input"
          placeholder="请输入贷款用途"
          :defaultValue="form.loanUse"
          v-model="form.loanUse"
        />
        <ContentComponent
          title="担保方式："
          mode="selector"
          :isRequire="true"
          multiple
          placeholder="请选择担保方式"
          :selectOptions="guaranteeMeansList"
          v-model="form.guaranteeMeansIds"
        />
        <ContentComponent
          title="经营地址："
          mode="cascader"
          :isRequire="true"
          placeholder="请选择区域"
          :cascaderOptions="areaList"
          v-model="form.enterpriseAreaIds"
        />
        <ContentComponent
          title
          mode="input"
          placeholder="请输入详细地址"
          :defaultValue="form.operateArea"
          v-model="form.operateArea"
        />
      </div>
      <div class="financing-apply__btn-container">
        <el-button class="financing-apply__btn-container__btn" type="primary" @click="handleSubmit"
          >提 交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Header2 from '@/components/Header/index'
import BreadcrumbGroup from '@/components/BreadcrumbGroup'
import FinancingProgress from './components/FinancingProgress'
import ContentComponent from '@/components/ContentComponent'
import { districtId } from '@/constant/index.js'
import { validateForm } from '@/utils/validate'
import {
  formatSubmitField
  //  syncCityInfo
} from '@/utils/common'
// eslint-disable-next-line no-shadow
import { Notification } from 'element-ui'
import {
  getApplyDeadline,
  getFinancType,
  getGuaranteeMeans,
  getFullAreaList
} from '@/utils/getSelectList'
import { mapState, mapActions } from 'vuex'
import Order from '@/mixins/Order'

export default {
  components: {
    Header2,
    BreadcrumbGroup,
    FinancingProgress,
    ContentComponent
  },
  mixins: [Order],
  created() {
    this.initForm()
    this.$_orderMixin_judgeIsGetHistoryEnterpriseAddressInfo({
      form: this.form,
      locationKeyName: 'enterpriseAreaIds',
      locationDetailKeyName: 'operateArea',
      enterpriseName: ''
    })
    this.getFullArea()
    let districtIdParam = this.cityInfo.district ? this.cityInfo.district.id : districtId
    this.getProductListCondition({ districtId: districtIdParam })
  },
  computed: {
    userType() {
      return this.$store.state.user.userType
    },
    // 期限范围
    applyDeadline() {
      return getApplyDeadline(this.listCondition)
    },
    // 融资类型
    financingCategory() {
      return getFinancType(this.listCondition).filter(condition => {
        if (this.userType === '法人') {
          return condition.id !== '119' && condition.id !== null
        }
        return true
      })
    },
    // 担保方式
    guaranteeMeansList() {
      // slice 发起融资多选 去掉不限选项
      return getGuaranteeMeans(this.listCondition).slice(1)
    },
    // 树形城市列表
    areaList() {
      return getFullAreaList(this.$store.state.area.fullAreaList)
    },
    ...mapState('product', {
      listCondition: state => state.listCondition,
      financingCondition: state => state.financingCondition
    }),
    ...mapState('user', {
      cityInfo: state => state.cityInfo
    })
  },
  watch: {
    cityInfo: function() {
      if (!this.cityInfo) {
        return
      }
      this.form.enterpriseAreaIds = [
        this.cityInfo.city && this.cityInfo.city.id,
        this.cityInfo.district && this.cityInfo.district.id
      ]
    }
  },
  methods: {
    initForm() {
      //  重置担保方式字符串为数组
      let guaranteeMeansIds = null
      if (this.financingCondition && this.financingCondition.guaranteeMeansIds) {
        guaranteeMeansIds = this.financingCondition.guaranteeMeansIds.split(',')
      }
      // 填写已填写过的表单
      this.form = {
        ...this.form,
        ...this.financingCondition,
        guaranteeMeansIds
      }

      if (this.userType === '个人') {
        this.form.financingCategory = '119'
      }

      //   if (this.cityInfo) {
      //     this.form.enterpriseAreaIds = [this.cityInfo.city.id, this.cityInfo.district.id]
      //   }
    },
    handleSubmit() {
      const validateResult = validateForm(this.form)
      if (validateResult !== true) {
        return Notification.warning({ title: '注意', message: validateResult })
      }
      const formatedForm = formatSubmitField(this.form)
      // syncCityInfo({
      //     vm: this,
      //     fullAreaList: this.fullAreaList,
      //     cityId: formatedForm.cityId,
      //     districtId: formatedForm.districtId
      // })
      this.$store.commit('product/SET_PRODUCT_LIST', [])
      this.$store.commit('product/SET_FINANCING_CONDITION', formatedForm)
      this.$router.push({ name: 'match-product' })
    },
    ...mapActions('product', ['getProductListCondition']),
    ...mapActions('area', ['getFullArea'])
  },
  data() {
    return {
      breadcrumb: [
        { name: '首页', routerName: 'home' },
        { name: '金融产品', routerName: 'product' },
        { name: '发起融资', routerName: 'financing-apply' }
      ],
      // 进度条设置
      progressInfoSetup: {
        mode: 'icon-dot',
        iconList: [
          { index: 1, name: '填写需求' },
          { index: 2, name: '匹配产品' },
          { index: 3, name: '提交申请' }
        ],
        class: {
          mainClass: 'dqProgress-main dot',
          itemTextClass: 'item-text-step',
          betweenBoxSize: 'between-box-71',
          betweenIcon: 'between-icon-dot'
        }
      },
      form: {
        amount: '', // 融资金额
        termRangeId: '', // 融资期限
        guaranteeMeansIds: '', // 担保方式
        timeLimit: '', // 输入的融资期限
        financingCategory: '', // 融资类型
        loanUse: '', // 资金用途
        enterpriseAreaIds: [], // ["经营地址 城市 code", "经营地址 地区 code"]
        operateArea: '' // 输入框的经营地址
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.financing-apply {
  @include common-layout;
  padding-bottom: 100px;

  &__progress-container {
    margin: 20px auto 0;
    width: 700px;
  }

  &__form {
    margin: 40px 0 50px;
  }

  &__btn-container {
    @include displayCenter;

    &__btn {
      width: 120px;
      height: 40px;
      font-size: 16px;
      position: relative;
      left: -8px;
    }
  }
}
</style>
